import axios from 'axios';

export const resettleTransaction = (payload) => {
  return axios.post(`/cms/transactions/adjust`, payload).then((res) => res.data);
};

export const cancelTransaction = (payload) => {
  return axios.post(`/cms/transactions/cancel`, payload).then((res) => res.data);
};

export const resyncTransaction = (payload) => {
  return axios.post(`/cms/transactions/resync`, payload).then((res) => res.data);
};

export const renewTransaction = (payload) => {
  return axios.post(`/cms/transactions/renew`, payload).then((res) => res.data);
};
